<svg-icon
  *ngIf="!pathStyle"
  [applyClass]="true"
  class="icon color-{{ color }} size-{{ size }}"
  [stretch]="true"
  [src]="iconPath"
></svg-icon>
<svg-icon
  *ngIf="pathStyle"
  [applyClass]="true"
  class="svg-path-{{ color }} size-{{ size }} icon"
  [stretch]="true"
  [src]="iconPath"
></svg-icon>
